import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-reset",
	templateUrl: "./reset.component.html",
	styleUrls: ["./reset.component.scss"]
})
export class ResetComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];
	private email: string;
	private code: string;

	public password = "";
	public password2 = "";
	public mfaCode = "";
	public showMfa = false;

	public errormessage: string;
	public success = false;

	constructor(public router: Router, private route: ActivatedRoute, private api: ApiService) { }

	ngOnInit() {
		this.subscriptions.push(this.route.queryParams.subscribe(params => {
			this.email = params["email"];
			this.code = params["code"];
		}));
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) {
			sub.unsubscribe();
		}
	}

	async Reset() {
		this.errormessage = undefined;
		this.success = false;
		if (this.password !== this.password2) {
			this.errormessage = "Passwords must match";
			return;
		}
		try {
			await this.api.ResetPassword(this.email, this.code, this.password, this.mfaCode);
			this.success = true;
		} catch (err) {
			if (err && err.status && (err.status === 400 || err.status === 401)) {
				if (err.error?.message === "MFA code is required") {
					this.showMfa = true;
				} else {
					if (this.showMfa) {
						this.errormessage = "Invalid MFA code";
					} else {
						this.errormessage = "Invalid email or reset code";
					}
				}
			} else {
				this.errormessage = "Reset failed";
			}
		}
	}

}
